module.exports = __webpack_public_path__ + "img/yuncaichaos.3dc70104.svg";